module.exports = __webpack_public_path__ + "img/37_34.0eb52449.png";